import { useNavigate } from 'react-router-dom';
import { Heart } from 'lucide-react';

export default function Privacy() {
  const navigate = useNavigate();

  return (
    <div className="app-container">
      <div className="px-4 py-6 pb-20">
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <button onClick={() => navigate('/')} className="text-white">
            ← Back
          </button>
          <Heart className="text-primary fill-primary" size={24} />
          <div className="w-8" />
        </div>

        <h1 className="text-white font-bold text-3xl mb-6">Privacy Policy</h1>

        <div className="space-y-6 text-gray-300 text-sm leading-relaxed">
          <section>
            <h2 className="text-white font-semibold text-lg mb-2">1. Data We Collect</h2>
            <p>We collect only the following information:</p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>Email address (for account creation)</li>
              <li>City, age range, gender, and interests (for matching)</li>
              <li>Chat messages (stored for service functionality)</li>
              <li>Payment information (processed by third parties)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-white font-semibold text-lg mb-2">2. What We Never Share</h2>
            <p>Your name and email address are NEVER shown to your matches or any other users. Your identity remains anonymous unless you choose to reveal it.</p>
          </section>

          <section>
            <h2 className="text-white font-semibold text-lg mb-2">3. How We Use Your Data</h2>
            <p>Your data is used exclusively for:</p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>Matching you with compatible users</li>
              <li>Facilitating anonymous communication</li>
              <li>Processing payments</li>
              <li>Improving our service</li>
            </ul>
          </section>

          <section>
            <h2 className="text-white font-semibold text-lg mb-2">4. Message Encryption</h2>
            <p>All messages are encrypted in transit using industry-standard HTTPS protocols. Messages are stored securely on our servers.</p>
          </section>

          <section>
            <h2 className="text-white font-semibold text-lg mb-2">5. Payment Security</h2>
            <p>We do not store credit card information. All payment processing is handled securely by Razorpay and Stripe, certified PCI-DSS compliant payment providers.</p>
          </section>

          <section>
            <h2 className="text-white font-semibold text-lg mb-2">6. Data Retention</h2>
            <p>We retain your data for as long as your account is active. You may request account deletion at any time by contacting us.</p>
          </section>

          <section>
            <h2 className="text-white font-semibold text-lg mb-2">7. Data Deletion</h2>
            <p>You have the right to request deletion of your personal data. Contact us at privacy@blindmatch.in to submit a deletion request.</p>
          </section>

          <section>
            <h2 className="text-white font-semibold text-lg mb-2">8. Third-Party Services</h2>
            <p>We use the following third-party services:</p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>Razorpay (payment processing)</li>
              <li>Stripe (payment processing)</li>
              <li>ipapi.co (geolocation for pricing)</li>
            </ul>
            <p className="mt-2">These services have their own privacy policies.</p>
          </section>

          <section>
            <h2 className="text-white font-semibold text-lg mb-2">9. DPDP Act Compliance (India)</h2>
            <p>We comply with India's Digital Personal Data Protection Act, 2023. Indian users have the right to access, correct, and delete their personal data.</p>
          </section>

          <section>
            <h2 className="text-white font-semibold text-lg mb-2">10. Cookies</h2>
            <p>We use minimal cookies for authentication and session management. No tracking or advertising cookies are used.</p>
          </section>

          <section>
            <h2 className="text-white font-semibold text-lg mb-2">11. Contact</h2>
            <p>For privacy concerns or data requests, contact: privacy@blindmatch.in</p>
          </section>

          <section className="text-xs text-gray-500">
            <p>Last updated: January 2026</p>
          </section>
        </div>
      </div>
    </div>
  );
}
